import Bishop from './Bishop';
import { BishopController } from './bishopController';

export default Bishop;
export { BishopController };